import { ListImage, Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import { UploadedLogosContainerStyled } from '../TechnicianBrowsedJobDetails/style';
import { DraftmanInformationStyled } from './style';

type Props = {
  imgUrl: { URL: string; id: string }[];
};

const DraftmanImageInformation = ({ imgUrl }: Props) => {
  return (
    <DraftmanInformationStyled>
      <Typography
        variant="normal"
        strong
        fontColor="secondary"
        className="section-title"
      >
        Drafts
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled $direction="column">
          {imgUrl.map((Props, index) => (
            <div key={index} className="draftmanInformation">
              <UploadedLogosContainerStyled>
                <ListImage
                  imagesURL={[{ URL: Props.URL, id: Props.id }]}
                  imageHeight="143px"
                  imageWidth="192px"
                />
              </UploadedLogosContainerStyled>
            </div>
          ))}
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </DraftmanInformationStyled>
  );
};

export default DraftmanImageInformation;
